import { createBrowserHistory } from "history";

const history = createBrowserHistory();

const convertToDate = (date) => {
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - (offset*60*1000))
    return date.toISOString().split('T')[0];

  }

export { history, convertToDate };
